import type { Card } from "@amzn/ads-blink-client";
import type {
    Content,
    ContentUser,
} from "@amzn/ads-discovery-theme-service-typescript-client";
import { useMemo } from "react";

import type { CardDetail } from "../../types/card";

import type { MarketingNarrativeDetailsType } from "./getMarketingNarrativeDetails";
import { getMarketingNarrativeDetails } from "./getMarketingNarrativeDetails";

export const useMarketingNarrativeDetails = (
    content: Content,
    contentUser: ContentUser[],
    viewType: MarketingNarrativeDetailsType,
): CardDetail[] => {
    const contentCategoryIds = content.contentCategoryIds ?? [];
    const details = useMemo(() => {
        return getMarketingNarrativeDetails(content, contentUser, viewType);
    }, [contentCategoryIds, viewType]);
    return details;
};

// Until we can reach UX alignment, we need to temporarily generate the old structure of card layouts using the new unified
// API response objects. This code should be removed once we reach alignment and replaced with a more graceful solution
export const useUnifiedMarketingNarrativeDetails = (
    content: Content,
    contentUser: ContentUser[],
    viewType: MarketingNarrativeDetailsType,
    unifiedCard?: Card,
): CardDetail[] => {
    const details = [
        {
            label: "Content Type",
            value: "Marketing Content",
            lineClamp: 1,
        },
        {
            label: "Marketplace",
            value: unifiedCard?.header,
            lineClamp: 1,
        },
        {
            label: "Language",
            value: unifiedCard?.subtitle,
            lineClamp: 1,
        },
        ...getMarketingNarrativeDetails(content, contentUser, viewType),
    ];
    return details;
};
